// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__XPnro","copy":"Footer_copy__cScla","link":"Footer_link__ntR5N"};